import { render } from "./deliveryRecord.vue?vue&type=template&id=6ea2129f&scoped=true&ts=true"
import script from "./deliveryRecord.vue?vue&type=script&lang=ts"
export * from "./deliveryRecord.vue?vue&type=script&lang=ts"

import "./deliveryRecord.vue?vue&type=style&index=0&id=6ea2129f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2129f"]])

export default __exports__